export class VueHelpers {
    constructor() {
        this.updateQueryString = function (name, value, remove = false) {
            if ('URLSearchParams' in window) {
                var searchParams = new URLSearchParams(window.location.search);
                if (!remove) {
                    searchParams.set(name, value);

                } else {
                    searchParams.delete(name);
                }
                const updatedUrl = window.location.protocol + "//" + window.location.host + window.location.pathname + '?' + searchParams.toString();
                window.history.replaceState({ path: updatedUrl }, '', updatedUrl);
            }
        };

        this.clearQueryString = function (clearTracking = false) {
            if (typeof URLSearchParams !== 'undefined') {

                if (window.location.search != "") {
                    const searchParams = new URLSearchParams(window.location.search)

                    searchParams.forEach((value, key) => {
                        if (key.includes('utm_') && !clearTracking) {
                            return;
                        } else {
                            searchParams.delete(key);
                        }
                    });

                    const updatedUrl = window.location.protocol + "//" + window.location.host + window.location.pathname + "?" + searchParams.toString();
                    window.history.replaceState({ path: updatedUrl }, '', updatedUrl);
                }

            }

        };

        this.scrollToTopOfFlow = function () {
            const component = document.querySelector('.p-sidebar-content');
            let componentTop = document.querySelector('.p-sidebar-header').offsetTop;
            component.scrollTop = componentTop;
        };

        this.getTimeDifferenceInSeconds = function (timestamp) {
            return Math.round(Date.now() / 1000) - Math.round(timestamp);
        };

        this.getTimestampInSeconds = function () {
            return Math.round(Date.now() / 1000);
        }

        this.getAntiForgeryToken = function () {
            return document.getElementById('RequestVerificationToken').value;
        }

        this.getLocalNumberString = function (number) {
            return number.toLocaleString('da-DK', {
                minimumFractionDigits: 0,
                maximumFractionDigits: 2
            });
        }

        this.shuffle = (array) => { 
            for (let i = array.length - 1; i > 0; i--) { 
              const j = Math.floor(Math.random() * (i + 1)); 
              [array[i], array[j]] = [array[j], array[i]]; 
            } 
            return array; 
          }; 

          this.getFuelTypeDisplayName = (fuelType) => {

            if (typeof fuelType != 'string') {
                fuelType = fuelType['value']; //The fuel type is an object when called from a MultuSelect. So we extract the value from the object.
            }

            switch (fuelType) {
                case "Gazoline":
                    return "Benzin";
                case "Diesel":
                    return "Diesel";
                case "Electricity":
                    return "El";
                case "Gas":
                    return "Gas";
                case "Hybrid":
                    return "Hybrid";
                case "Unknown":
                default:
                    return "Ukendt";
            }
        }

        this.brandsSortingObject = ["audi", "volkswagen", "skoda", "seat", "cupra", "volkswagen erhverv"];

        this.flowNameQueryKey = "flowName";
        this.flowStepQueryKey = "flowStep";
        this.initSemlerSwiperKey = "initSemlerSwiper";
        this.loginRedirectUrlKey = "loginRedirectUrl"
        this.favoritesCacheKey = "favorites";
        this.vehicleCardDictionaryCacheKey = "vehicleCardDictionary";

    }
};
export default new VueHelpers();